exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-code-red{color:var(--v-error-darken2)}.status-code-green{color:var(--v-primary-darken2)}", ""]);

// exports
